import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { getSignature } from 'modules/zoom/actions';
import ZoomMeeting from '../components';

function mapStateToProps(state) {
  return {
    app: state.app,
    zoomData: state.zoom,
    user: state.session.user,
    literals: state.i18n.literals.zoomMeeting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getSignature: bindActionCreators(getSignature, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ZoomMeeting));



// WEBPACK FOOTER //
// ./src/components/ZoomMeeting/container/index.js